var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"70%"},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}},[_c('v-card',[_c('v-card-title',[_c('span',[_vm._v("Populate ")])]),_c('v-card-text',{staticClass:"farmer-assign-wrapper mt-3"},[_c('div',[_c('h1',[_vm._v("hello")])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }